'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
/**
 * Intro.js options default proptypes.
 * @type {Object}
 */
var options = (exports.options = {
  hidePrev: true,
  hideNext: true,
});
